import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getConversations } from "../../redux/actions/chat";
import { base, formatTime, truncateString } from "../../constants/base";
import ChatBox from "../ChatBox/ChatBox";
import EmptyState from "../EmptyState/EmptyState";

const Chat = () => {
  const dispatch = useDispatch();
  const chat = useSelector((state) => state.chat);
  const user = useSelector((state) => state.AuthSlice.user);
  const [inputMessageId, setInputMessageId] = useState(null);

  useEffect(() => {
    if (user?.id) {
      dispatch(getConversations(user?.id));
    }
  }, [user?.id]);

  useEffect(() => {
    if (chat.conversations?.data?.length > 0 && !inputMessageId) {
      setInputMessageId(chat.conversations.data[0].id);
    }
  }, [chat.conversations]);

  const hasConversations = chat.conversations?.data?.length > 0;

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className={hasConversations ? "col-xl-3 col-lg-3 col-md-12" : "col-md-12"}>
            <div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home-tab-pane"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                  tabIndex={0}
                >
                  {chat.conversations?.data &&
                  chat?.conversations?.data?.length > 0 ? (
                    chat.conversations?.data.map((conversation) => (
                      <div
                        key={conversation.id}
                        className="message-box"
                        onClick={() => {
                          setInputMessageId(conversation.id);
                        }}
                      >
                        <div className="position-relative">
                          <img
                            className="message-image"
                            src={
                              conversation?.receiver?.id == user?.id
                                ? base.imageUrl +
                                  conversation?.sender?.images?.[0]?.path
                                : base.imageUrl +
                                  conversation?.receiver?.images?.[0]?.path
                            }
                            alt=""
                          />
                        </div>

                        <div className="message-text-box">
                          <p>
                            {conversation?.messages &&
                              conversation?.messages[
                                conversation.messages?.length - 1
                              ]?.created_at &&
                              formatTime(
                                conversation?.messages[
                                  conversation.messages?.length - 1
                                ]?.created_at
                              )}
                          </p>
                          <h1>
                            {conversation?.receiver?.id == user?.id
                              ? conversation?.sender?.name
                              : conversation?.receiver?.name}{" "}
                            <span className="active-dot"></span>
                          </h1>
                          <h3>
                            {conversation?.messages &&
                              conversation.messages?.length > 0 &&
                              truncateString(
                                conversation?.messages[
                                  conversation.messages?.length - 1
                                ]?.message,
                                10
                              )}
                          </h3>
                        </div>
                      </div>
                    ))
                  ) : (
                    <EmptyState
                      title="No Conversations Yet"
                      message="Start a conversation to see it here."
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          {inputMessageId && <ChatBox id={inputMessageId} />}
        </div>
      </div>
    </>
  );
};

export default Chat;
